import React, {Component} from 'react'
import { Sheet, Box, Grid, Typography, Input, Button, FormControl, FormLabel, Divider, Stack } from '@mui/joy'
import {getFormData} from '../shared/utils'
import loginBg from '../assets/images/login-bg-2.jpg'

export class Login extends Component {

  constructor(props) {
    super(props)
    props.setTitle('Sign in')
    this.state = {
      submit: this.submit.bind(this),
      submitRegistration: this.submitRegistration.bind(this),
      continueWithGoogle: this.continueWithGoogle.bind(this),
      toggleMode: this.toggleMode.bind(this),
      mode: 'login',
      isLoading: false,
    }
  }

  async submit(evt) {
    evt.preventDefault()
    this.setState({ isLoading: true })
    const {username, password} = getFormData(evt.target)
    try {
      await this.props.logIn(username, password)
    } catch (error) {
      console.error('Login failed.');
      setTimeout(() => {this.setState({ isLoading: false })}, 300);
    } finally {
     
    }
    return false
  }

  async submitRegistration(evt) {
    evt.preventDefault()
    this.setState({ isLoading: true })
    const {reg_fullname, reg_email, reg_password, reg_confirm_password} = getFormData(evt.target)
    if (reg_password !== reg_confirm_password) {
      console.warn('Passwords do not match')
      this.setState({ isLoading: false })
      return false
    }
    try {
      if (typeof this.props.registerEmail === 'function') {
        await this.props.registerEmail({ fullname: reg_fullname, email: reg_email, password: reg_password })
      } else {
        console.warn('registerEmail prop is not provided. Implement backend registration to enable this.')
      }
    } catch (error) {
      console.error('Registration failed:', error)
    } finally {
      this.setState({ isLoading: false })
    }
    return false
  }

  async continueWithGoogle(evt) {
    evt && evt.preventDefault && evt.preventDefault()
    this.setState({ isLoading: true })
    try {
      if (typeof this.props.logInWithGoogle === 'function') {
        await this.props.logInWithGoogle()
      } else {
        console.warn('Google Sign-In not configured. Provide logInWithGoogle prop to enable this flow.')
      }
    } catch (error) {
      console.error('Google Sign-In failed:', error)
    } finally {
      this.setState({ isLoading: false })
    }
    return false
  }

  toggleMode() {
    this.setState(({mode}) => ({ mode: mode === 'login' ? 'register' : 'login' }))
  }

  render() {
    const {submit, submitRegistration, continueWithGoogle, toggleMode, mode, isLoading} = this.state
    const isLogin = mode === 'login'

    return (
      <Box sx={{ position: 'relative', minHeight: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden',
        backgroundImage: `linear-gradient(180deg, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.35) 60%, rgba(0,0,0,0.45) 100%), url(${loginBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}>
        {/* Noise overlay using SVG turbulence */}
        <Box aria-hidden="true" sx={{ position: 'absolute', inset: 0, pointerEvents: 'none', opacity: 0.06,
          backgroundImage: `url("data:image/svg+xml;utf8,${encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><filter id="n"><feTurbulence type="fractalNoise" baseFrequency="0.8" numOctaves="4" stitchTiles="stitch"/></filter><rect width="100%" height="100%" filter="url(#n)"/></svg>')}" )`,
        }} />

        <Box sx={{ width: '100%', maxWidth: 500, px: 2, mb: '60px' }}>
          <Grid container>
            <Grid xs={12}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                <Box>
                  <Typography level="h3" sx={{ color: '#fff' }}>{isLogin ? 'Welcome back' : 'Create your account'}</Typography>
                  <Typography level="body-sm" sx={{ color: 'rgba(255,255,255,0.85)' }}>
                    {isLogin ? 'Sign in to continue' : 'Sign up to get started'}
                  </Typography>
                </Box>
                {/* It's hidden temporarily    
                <Button variant="soft" color="neutral" onClick={toggleMode}>
                  {isLogin ? 'Create account' : 'Sign in'}
                </Button>
                 */}
              </Box>
            </Grid>
          </Grid>

          {true && isLogin ? (
            <Sheet variant="soft" sx={{ p: 3, borderRadius: 'md', backdropFilter: 'saturate(120%) blur(8px)',
              backgroundColor: 'rgba(255,255,255,0.85)' }}>
              <form onSubmit={submit}>
                <Stack spacing={1.5}>
                  <FormControl>
                    <FormLabel>Username or email</FormLabel>
                    <Input type="text" placeholder="you@example.com" autoFocus required 
                      slotProps={{ input: { id: 'username', name: 'username', autoComplete: 'username' } }} />
                  </FormControl>
                  <FormControl>
                    <FormLabel>Password</FormLabel>
                    <Input type="password" placeholder="••••••••" required 
                      slotProps={{ input: { id: 'password', name: 'password', autoComplete: 'current-password' } }} />
                  </FormControl>
                  <Button type="submit" color="primary" loading={isLoading}
                  className={'btn-custom-primary-solid'}>Sign in</Button>
                  
                  <Divider hidden>or</Divider>
                  <Button hidden variant="outlined" color="danger" onClick={continueWithGoogle} type="button" loading={isLoading}>
                    Continue with Google
                  </Button>
                </Stack>
              </form>
            </Sheet>
          ) : (
            <Sheet variant="soft" sx={{ p: 3, borderRadius: 'md', backdropFilter: 'saturate(120%) blur(8px)',
              backgroundColor: 'rgba(255,255,255,0.85)' }}>
              <form onSubmit={submitRegistration}>
                <Stack spacing={1.5}>
                  <FormControl>
                    <FormLabel>Full name</FormLabel>
                    <Input type="text" placeholder="Jane Doe" required 
                      slotProps={{ input: { id: 'reg_fullname', name: 'reg_fullname', autoComplete: 'name' } }} />
                  </FormControl>
                  <FormControl>
                    <FormLabel>Email address</FormLabel>
                    <Input type="email" placeholder="you@example.com" required 
                      slotProps={{ input: { id: 'reg_email', name: 'reg_email', autoComplete: 'email' } }} />
                  </FormControl>
                  <FormControl>
                    <FormLabel>Password</FormLabel>
                    <Input type="password" placeholder="Create a password" required 
                      slotProps={{ input: { id: 'reg_password', name: 'reg_password', autoComplete: 'new-password' } }} />
                  </FormControl>
                  <FormControl>
                    <FormLabel>Confirm password</FormLabel>
                    <Input type="password" placeholder="Repeat your password" required 
                      slotProps={{ input: { id: 'reg_confirm_password', name: 'reg_confirm_password', autoComplete: 'new-password' } }} />
                  </FormControl>
                  <Button type="submit" color="success" loading={isLoading}>Create account</Button>
                </Stack>
              </form>
            </Sheet>
          )}
        </Box>
      </Box>
    )
  }
}
